import { chatService } from './chat.service';
import { apiRoutes } from './routes';
import { getUrlParam, isAppIntegrationRoute } from 'utils/embedParams';

const getLogoutUrl = (): string => {
    const apiUrl = process.env.REACT_APP_API_URL?.replace(/\/$/, '');
    return apiUrl ? `${apiUrl}${apiRoutes.logout}` : apiRoutes.logout;
};

const getLogoutHeaders = (): Record<string, string> => {
    const headers: Record<string, string> = {};
    const conversationId = sessionStorage.getItem('conversationId');

    if (conversationId) {
        headers['x-conversation-id'] = conversationId;
    }

    if (isAppIntegrationRoute()) {
        const exchangeHeaders: Record<string, string> = {
            'X-Exchange-Token': 'x-exchange-token',
            'X-Exchange-Provider': 'x-exchange-provider',
            'X-Exchange-Signature': 'x-exchange-signature',
            'X-Exchange-Timestamp': 'x-exchange-timestamp'
        };

        Object.entries(exchangeHeaders).forEach(([headerName, paramName]) => {
            const value = getUrlParam(paramName);
            if (value) {
                headers[headerName] = value;
            }
        });
    }

    return headers;
};

export const authService = {
    logout: async () => {
        try {
            await chatService.post(apiRoutes.logout);
            
            sessionStorage.clear();
          
            return { success: true };
        } catch (error) {
            console.error('Logout error:', error);
            
            // Even if API call fails, clear local storage
            sessionStorage.clear();
            
            throw error;
        }
    },

    /**
     * Send logout while the document is leaving the app. `keepalive` allows
     * the browser to continue the small POST after React has started
     * unmounting the page.
     */
    logoutOnPageExit: (): void => {
        const requestUrl = getLogoutUrl();
        const headers = {
            'Content-Type': 'application/json',
            ...getLogoutHeaders()
        };

        if (typeof fetch === 'function') {
            void fetch(requestUrl, {
                method: 'POST',
                headers,
                body: '{}',
                credentials: 'include',
                keepalive: true
            }).catch(() => {
                // The page is already leaving; there is no UI to report this to.
            });
        } else if (navigator.sendBeacon) {
            // Fallback for older WebViews without fetch keepalive support.
            navigator.sendBeacon(
                requestUrl,
                new Blob(['{}'], { type: 'application/json' })
            );
        }

        sessionStorage.clear();
    }

};
